// extracted by css-extract-rspack-plugin
var _1 = "src-components-Base-ContextMenu-ContextMenu-module__closing-k_BRuZ";
var _2 = "src-components-Base-ContextMenu-ContextMenu-module__contextMenu-dTANBG";
var _3 = "src-components-Base-ContextMenu-ContextMenu-module__danger-u5NYV3";
var _4 = "src-components-Base-ContextMenu-ContextMenu-module__divider-gu97_A";
var _5 = "src-components-Base-ContextMenu-ContextMenu-module__fadeInScaleMenu-AxWEYG";
var _6 = "src-components-Base-ContextMenu-ContextMenu-module__fadeOutScaleMenu-qPb1I6";
var _7 = "src-components-Base-ContextMenu-ContextMenu-module__icon-MzPrDb";
var _8 = "src-components-Base-ContextMenu-ContextMenu-module__menuItem-jzkzd9";
export { _1 as "closing", _2 as "contextMenu", _3 as "danger", _4 as "divider", _5 as "fadeInScaleMenu", _6 as "fadeOutScaleMenu", _7 as "icon", _8 as "menuItem" }

    if(module.hot) {
      (function() {
        var localsJsonString = "{\"closing\":\"src-components-Base-ContextMenu-ContextMenu-module__closing-k_BRuZ\",\"contextMenu\":\"src-components-Base-ContextMenu-ContextMenu-module__contextMenu-dTANBG\",\"danger\":\"src-components-Base-ContextMenu-ContextMenu-module__danger-u5NYV3\",\"divider\":\"src-components-Base-ContextMenu-ContextMenu-module__divider-gu97_A\",\"fadeInScaleMenu\":\"src-components-Base-ContextMenu-ContextMenu-module__fadeInScaleMenu-AxWEYG\",\"fadeOutScaleMenu\":\"src-components-Base-ContextMenu-ContextMenu-module__fadeOutScaleMenu-qPb1I6\",\"icon\":\"src-components-Base-ContextMenu-ContextMenu-module__icon-MzPrDb\",\"menuItem\":\"src-components-Base-ContextMenu-ContextMenu-module__menuItem-jzkzd9\"}";
        // 1752373455120
        var cssReload = require("../../../../node_modules/.pnpm/@rspack+core@1.4.6_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  